"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8M7 9.5C7 8.67 7.67 8 8.5 8s1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5m8 6H9V14h6zm.5-4.5c-.83 0-1.5-.67-1.5-1.5S14.67 8 15.5 8s1.5.67 1.5 1.5-.67 1.5-1.5 1.5",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M9 14h6v1.5H9z"
}, "1"), /*#__PURE__*/_jsx("circle", {
  cx: "15.5",
  cy: "9.5",
  r: "1.5"
}, "2"), /*#__PURE__*/_jsx("circle", {
  cx: "8.5",
  cy: "9.5",
  r: "1.5"
}, "3"), /*#__PURE__*/_jsx("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}, "4")], 'SentimentNeutralTwoTone');